<template>
  <b-modal
    ref="modal"
    size="lg"
    title="Enter URLs"
    @ok="ok"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <template #modal-ok>
      {{ uploadMethod === 'bookmark' ? 'Save' : 'Upload' }}
    </template>

    <div class="form-group">
      <div class="urls-container">
        <div class="form-group">
          <label class="input-label">
            URLs
            <a
              style="color: #727272;"
              href="#"
              class="image-compress-max-size-tooltip"
              data-toggle="tooltip"
              title="Upload from URL or save bookmark"
            >
              <i class="fa fa-info-circle" />
            </a>
          </label>
          <textarea 
            id="extenal_file_url"
            v-model="urls"
            type="url"
            class="form-control"
            name="extenal_file_url"
            placeholder="https://..."
            rows="4"
          />
        </div>
        <div class="mt-1">
          <div class="form-group mb-1">
            <input
              id="upload_from_web"
              v-model="uploadMethod"
              type="radio"
              name="upload_from_web"
              value="upload"
            >
            <label for="upload_from_web">Upload from web</label>
          </div>
          <div
            v-if="!isProducts"
            class="form-group"
          >
            <input
              id="just_store_from_web"
              v-model="uploadMethod"
              type="radio"
              name="upload_from_web"
              value="bookmark"
            >
            <label for="just_store_from_web">Save as bookmark</label>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { fetchFileData, getFileNameFromURL } from '@frontend/utils'
import mixin from "./mixin";
import {TABS} from "../constants";
import {MUTATIONS} from "../../../../store/file-browser";

const { mapActions, mapGetters, mapMutations } = createNamespacedHelpers('fileBrowser')
const { mapActions: mapProductActions } = createNamespacedHelpers('productImageSelector');


export default {
  name: "CreateLinkModal",
  mixins: [mixin],
  data: () => ({
    urls: '',
    uploadMethod: 'upload',
  }),
  computed: {
    isProducts() {
      return this.$route?.params?.tab === TABS.PRODUCTS
    },
  },
  methods: {
    ...mapActions(['uploadFiles', 'storeExternalLinks']),
    ...mapProductActions(['uploadProductImages', 'fetchCurrentBrowserData']),
    ...mapMutations({
      setListLoading: MUTATIONS.SET_LIST_LOADING
    }),
    onModalShown() {
      this.$root.$emit('link-modal-shown');
    },
    onModalHidden() {
      this.$root.$emit('link-modal-hidden');
    },
    async ok () {
      let all_urls = (this.urls || [])
        .split('\n')
        .map(u => u.trim())
        .filter(u => u.length > 0);
      let files = [];
      if (this.uploadMethod === 'upload') {
        for (const url of all_urls) {
          try {
            const file = await fetchFileData(url);
            files.push(file);
          } catch (err) {
            console.error('Failed to fetch file from URL:', url, err);
          }
        }

        if (this.isProducts) {
          this.setListLoading(true);
          let folderId = this.currentFolderId || null;
          // If folderId not defined, try to extract from route
          if (!folderId && this.$route?.params?.pathMatch) {
            folderId = this.$route.params.pathMatch.split('/').pop();
          }
          await this.uploadProductImages({
            files,
            folderId,
          });

          await this.$store.dispatch('fileBrowser/fetchList');
        }else {
          if (files.length > 0) {
            this.uploadFiles({
              files: files,
            });
          }
        }
      } else {
        for (let i = 0; i < all_urls.length; i++) {
          files.push({
            url: all_urls[i],
            name: getFileNameFromURL(all_urls[i]),
          });
        }
        if (files.length > 0) {
          this.storeExternalLinks({
              files: files,
            });
        }
      }

      this.urls = "";
    },
  }

}
</script>

<style scoped lang="scss">

</style>
